import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../hooks/useCart";
import {
  PageTitle,
  CartItem,
  CartItemImage,
  CartItemInfo,
  CartItemName,
  CartItemPrice,
  QuantityControls,
  QuantityButton,
  QuantityDisplay,
  CartSummary,
  CartTotal,
  Button,
  EmptyCart,
} from "../components/styled";

export const CartPage: React.FC = () => {
  const { state, updateQuantity, removeItem, clearCart } = useCart();
  const navigate = useNavigate();

  if (state.items.length === 0) {
    return (
      <EmptyCart>
        <h2>Your cart is empty</h2>
        <p>Add some products to get started!</p>
        <Button
          onClick={() => navigate("/")}
          style={{ width: "auto", margin: "2rem auto 0" }}
        >
          Continue Shopping
        </Button>
      </EmptyCart>
    );
  }

  const handleQuantityChange = (productId: number, newQuantity: number) => {
    if (newQuantity === 0) {
      removeItem(productId);
    } else {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleCheckout = () => {
    // Full navigation, not client-side routing, so the edge waiting-room filter
    // on /checkout actually sees the request. Client-side routing would make the
    // checkout page unreachable to the gate. The cart survives via localStorage
    // (see CartContext).
    window.location.assign("/checkout");
  };

  return (
    <>
      <PageTitle>Shopping Cart</PageTitle>

      <div>
        {state.items.map((item) => (
          <CartItem key={item.product.id}>
            <CartItemImage src={item.product.image} alt={item.product.name} />
            <CartItemInfo>
              <CartItemName>{item.product.name}</CartItemName>
              <CartItemPrice>${item.product.price.toFixed(2)}</CartItemPrice>
            </CartItemInfo>
            <QuantityControls>
              <QuantityButton
                onClick={() =>
                  handleQuantityChange(item.product.id, item.quantity - 1)
                }
              >
                -
              </QuantityButton>
              <QuantityDisplay>{item.quantity}</QuantityDisplay>
              <QuantityButton
                onClick={() =>
                  handleQuantityChange(item.product.id, item.quantity + 1)
                }
              >
                +
              </QuantityButton>
            </QuantityControls>
            <Button
              onClick={() => removeItem(item.product.id)}
              style={{
                background: "#dc3545",
                width: "auto",
                padding: "0.5rem 1rem",
              }}
            >
              Remove
            </Button>
          </CartItem>
        ))}
      </div>

      <CartSummary>
        <CartTotal>Total: ${state.total.toFixed(2)}</CartTotal>
        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          <Button
            onClick={clearCart}
            style={{
              background: "#6c757d",
              width: "auto",
            }}
          >
            Clear Cart
          </Button>
          <Button onClick={handleCheckout} style={{ width: "auto" }}>
            Proceed to Checkout
          </Button>
        </div>
      </CartSummary>
    </>
  );
};
